export var USER_FIELD_TYPE = 'com.atlassian.jira.user.ApplicationUser';